export default "__VITE_ASSET__41792c61__"